import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { NoticeSectionDTO } from '@lib/strapi/dtos/components/sections/noticeSection.dto';
import { Prose } from '../shared-ui';
import { IconDoc } from '@components/utils/icons';

/**
 * Callout for must-not-miss practical info («Τι να έχετε μαζί σας…»).
 * Promoted from a quiet left-rule strip to a proper card (owner, 2026-09-08:
 * it needs to be prominent — a visitor preparing for the first visit must
 * not scroll past it): icon badge, tinted card, full-size text.
 */
const NoticeSectionImplementation = ({ section }: ComponentProps<NoticeSectionDTO>) => {
  if (!section) return null;
  const heading = (section as { heading?: string }).heading;
  return (
    <aside className="my-8 flex gap-4 rounded-2xl border-2 border-violet-200 bg-violet-050 p-5 md:items-center md:gap-5 md:p-6">
      <span className="grid h-11 w-11 flex-none place-items-center rounded-xl bg-violet-700 text-white shadow-[0_6px_16px_rgba(102,0,204,0.28)] md:h-12 md:w-12"
        aria-hidden="true">
        <IconDoc width={22} height={22} />
      </span>
      <div className="min-w-0">
        {heading ? <p className="font-extrabold text-ink">{heading}</p> : null}
        <Prose
          content={(section as unknown as { content?: import("next-mdx-remote").MDXRemoteSerializeResult }).content}
          className="[&_.prose-content]:max-w-none [&_p:last-child]:mb-0 [&_strong]:text-violet-700"
        />
      </div>
    </aside>
  );
};

export default NoticeSectionImplementation;
